/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UnlistedInputs */

const en_unlisted = /** @type {(inputs: UnlistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlisted`)
};

const de_unlisted = /** @type {(inputs: UnlistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht gelistet`)
};

/**
* | output |
* | --- |
* | "Unlisted" |
*
* @param {UnlistedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const unlisted = /** @type {((inputs?: UnlistedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UnlistedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unlisted(inputs)
	return de_unlisted(inputs)
});